import type { FC } from 'react';

import useAccountRouter from 'Components/Account/useAccountRouter';

import { shouldDisplayFeesView, showDisplayBiddingView } from '../PurchasesVehicleListValueCell.helpers';

import { BiddingSavingsView } from './BiddingSavingsView';
import { FeeCollectionView } from './FeeCollectionView';

type ViewSwitchProps = {
	brokerFeeAmount?: number;
	finalOfferAmount?: number;
	hasFees: boolean;
	maximumBid: Nullable<number>;
	mechanicalGuaranteeFeeAmount?: number;
	mechanicalGuaranteePromotionalRate?: boolean;
	totalPaymentAmount?: number;
	transportFeeAmount?: number;
	type: string;
	value: number;
};

export const ViewSwitch: FC<ViewSwitchProps> = ({
	brokerFeeAmount,
	finalOfferAmount,
	hasFees,
	maximumBid,
	mechanicalGuaranteeFeeAmount,
	mechanicalGuaranteePromotionalRate,
	totalPaymentAmount,
	transportFeeAmount,
	type,
	value,
}) => {
	const { slug } = useAccountRouter();

	const displayFeesView = shouldDisplayFeesView(hasFees);
	const displayBiddingView = showDisplayBiddingView(hasFees);

	if (displayFeesView) {
		return (
			<FeeCollectionView
				{...{
					brokerFeeAmount,
					finalOfferAmount,
					mechanicalGuaranteeFeeAmount,
					mechanicalGuaranteePromotionalRate,
					slug: String(slug),
					totalPaymentAmount,
					transportFeeAmount,
				}}
			/>
		);
	}

	if (displayBiddingView) {
		return <BiddingSavingsView {...{ maximumBid: maximumBid as number, slug: String(slug), type, value }} />;
	}

	return <></>;
};
